/**
 * Подсказка следующего шага (§24.3).
 *
 * Назначение файла: вывести из состояния игрока один совет — что сделать сейчас.
 * Шаг считается по состоянию, а не по счётчику пройденных уроков: игрок, который
 * поставил Очаг с телефона, не должен получить на сайте совет поставить его снова.
 *
 * Здесь нет ни React, ни запросов: только правила, поэтому шаги проверяются тестами.
 */

/** Шаги в том порядке, в котором игра их предлагает. */
export type OnboardingStep = "hearth" | "walk" | "ritual" | "collect" | null;

export interface OnboardingInput {
  /** Очаг поставлен. */
  readonly hasHearth: boolean;
  /** Есть хотя бы один живой Верный След. */
  readonly hasValidTrace: boolean;
  /** Игрок владеет хотя бы одной сотой. */
  readonly ownsHex: boolean;
  /** В казне своих сот есть что забрать. */
  readonly vaultReady: boolean;
}

/**
 * Следующий шаг игрока или `null`, если обучение закончено.
 *
 * Порядок проверок и есть порядок обучения: дом, ноги, земля, деньги.
 */
export function nextOnboardingStep(input: OnboardingInput): OnboardingStep {
  if (!input.hasHearth) return "hearth";
  if (!input.hasValidTrace && !input.ownsHex) return "walk";
  if (!input.ownsHex) return "ritual";
  if (input.vaultReady) return "collect";
  return null;
}

/** Ключ подсказки в каталоге `onboarding`. */
export function stepMessageKey(step: Exclude<OnboardingStep, null>): string {
  return `onboarding:hint.${step}`;
}
